import React from "react";
import { Bar } from "react-chartjs-2";

const BillingStatsChart = (props) => {
  //console.log("props", props);
  const labels = ["Billing Stats"];
  const data = {
    labels: labels,
    datasets: [
      {
        label: "ELLIGIBLE FOR BHI",
        backgroundColor: "#1E90FF",
        borderColor: "#1E90FF",
        data: labels.map(() => props.bhiEligibleCount),
      },
      {
        label: "ENROLLED IN BHI",
        backgroundColor: "#20B2AA",
        borderColor: "#20B2AA",
        data: labels.map(() => props.bhiEnrolledCount),
      },
      {
        label: "ELLIGIBLE FOR BHI BILLING",
        backgroundColor: "#00BFFF",
        borderColor: "#00BFFF",
        data: labels.map(() => props.bhiBillingCount),
      },
    ],
  };
  const BarChart = () => {
    return (
      <div className="col-sm-7 col-md-7 col-lg-7">
        <Bar
          data={data}
          options={{
            legend: {
              labels: {
                usePointStyle: true,
                boxWidth: 6,
              },
            },
            scales: {
              x: {
                gridLines: {
                  display: false,
                },
              },
              y: {
                beginAtZero: true,
                max: 120,
                title: {
                  display: true,
                  text: "Count",
                  color: "gray",
                  font: {
                    family: "Times",
                    size: 20,
                    style: "normal",
                    lineHeight: 1.2,
                  },
                  padding: { top: 30, left: 0, right: 0, bottom: 0 },
                },
                type: "linear",
                ticks: {
                  stepSize: 20,
                },
                gridLines: {
                  display: true,
                },
              },
            },
          }}
        />
      </div>
    );
  };

  return <BarChart />;
};

export default BillingStatsChart;
